import Link from 'next/link'
import React from 'react'

// Domestic services beyond a regular part-time helper visit. Each card links to
// its own page. Rates, job scope and guides are in the hub's RelatedLinks grid,
// so they aren't repeated here.
const services = [
  {
    title: "Professional House Cleaning",
    desc: "Get your home deeply cleaned by experienced pros for a healthier, more hygienic space.",
    href: "/sg/part-time-cleaner-singapore/professional-house-cleaning",
    icon: "🏠",
    gradient: "from-blue-600 to-cyan-400"
  },
  {
    title: "Move-in Move-out Cleaning",
    desc: "Cleaning solution for moving into or vacating homes, including end-of-lease cleanups.",
    href: "/sg/part-time-cleaner-singapore/move-in-move-out-cleaning",
    icon: "📦",
    gradient: "from-gray-600 to-stone-400"
  },
  {
    title: "Spring Cleaning",
    desc: "Deep cleaning, decluttering and organising when the home needs more than a regular visit.",
    href: "/sg/part-time-cleaner-singapore/spring-cleaning",
    icon: "✨",
    gradient: "from-green-600 to-lime-400"
  },
  {
    title: "Helper For Cooking Assistance",
    desc: "Need help in the kitchen? Our helpers assist with meal prep and simple cooking tasks.",
    href: "/sg/part-time-cleaner-singapore/part-time-helper-for-cooking",
    icon: "👩‍🍳",
    gradient: "from-purple-600 to-pink-400"
  },
  {
    title: "Part Time Babysitter",
    desc: "Reliable babysitters to engage your kids, maintain routines, and keep things tidy.",
    href: "/sg/part-time-cleaner-singapore/part-time-babysitter-singapore",
    icon: "🧸",
    gradient: "from-red-600 to-rose-400"
  },
  {
    title: "Elderly Care",
    desc: "Reliable helpers to take care of the elderly in your family, by the hour.",
    href: "/sg/part-time-cleaner-singapore/elderly-care",
    icon: "🧓",
    gradient: "from-yellow-600 to-yellow-200"
  },
]

export const PartTimeHelperServices = () => (
  <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {services.map(({ title, desc, href, icon, gradient }) => (
      <li key={href}>
        <Link
          href={href}
          prefetch={false}
          className="h-full bg-white rounded-3xl border border-gray-200 hover:border-orange-300 hover:shadow-md transition p-5 flex gap-4 items-start"
        >
          <span
            aria-hidden="true"
            className={`shrink-0 text-3xl rounded-full w-14 h-14 flex items-center justify-center bg-linear-to-tr ${gradient}`}
          >
            {icon}
          </span>
          <div className="min-w-0">
            <h3 className="font-bold text-gray-900">{title}</h3>
            <p className="text-sm text-gray-600 leading-relaxed mt-1">{desc}</p>
          </div>
        </Link>
      </li>
    ))}
  </ul>
)
